import { colorSet } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';
import { CommonLayoutStyleProps } from './types';

export const useCommonLayoutStyles = makeStyles<Theme, CommonLayoutStyleProps>(
  (theme) => ({
    container: {
      width: '100vw',
      height: '100vh',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
      }
    },
    header: {
      position: 'fixed',
      top: 0,
      width: '100vw',
      height: 80,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0px 24px',
      zIndex: 3,
      pointerEvents: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: '0px 16px',
        height: 64,
        '& .mobile-close-button': {
          backgroundColor: `rgba(255, 255, 255, 0.2)`,
          color: colorSet.gray000,
          pointerEvents: 'auto',
          '&.MuiIconButton-root': {
            width: 32,
            height: 32,
            padding: 0
          }
        }
      },
      '& img': {
        '&:hover': { cursor: 'pointer' },
        pointerEvents: 'auto'
      },
      '& .subButton': {
        minWidth: 'unset',
        borderRadius: '50px',
        backgroundColor: colorSet.gray200,
        color: colorSet.gray900,
        pointerEvents: 'auto',
        [theme.breakpoints.down('sm')]: {
          height: 32,
          backgroundColor: `rgba(255, 255, 255, 0.2)`,
          color: colorSet.gray000
        }
      }
    },
    titleSection: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      width: '100%',
      height: '100%',
      backgroundImage: ({ titleBackgroundImage }) =>
        `url(${titleBackgroundImage})`,
      background: ({ titleBackgroundColor }) => titleBackgroundColor,
      backgroundSize: 'cover',
      color: colorSet.gray000,
      whiteSpace: 'pre-line',
      gap: '4px',
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        height: 216,
        whiteSpace: 'nowrap',
        padding: '0px 16px',
        backgroundPosition: 'center'
      }
    },
    titleWrapper: {
      width: '100%',
      height: '100vh',
      backgroundColor: ({ titleBackgroundImage }) =>
        titleBackgroundImage ? `rgba(0, 0, 0, ${0.5})` : `rgba(0, 0, 0, ${0})`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '0px 48px',
      '& .service-simple-description': {
        whiteSpace: 'pre'
      },
      [theme.breakpoints.down('sm')]: {
        padding: '0px 16px',
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        color: colorSet.gray000,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        opacity: 1
      }
    },
    contentSection: {
      flex: 1.74,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      backgroundColor: colorSet.gray000,
      paddingTop: 0,
      overflow: 'auto',
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        minHeight: '100vh',
        top: 160,
        borderRadius: '16px 16px 0px 0px',
        '& .paperTop': {
          height: '0px'
        }
      }
    }
  })
);
